import React, { Component } from "react";
import { Bar } from 'react-chartjs-2';  
class DiagramMhsAsing extends Component {
    
      options = {
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    userCallback: function(label, index, labels) {
                        // when the floored value is the same as the value we have a whole number
                        if (Math.floor(label) === label) {
                            return label;
                        }
   
                    },
                }
            }],
        },
    }
    render(){
        // console.log("data hshshs= ", this.props.dataMhs.data_mhs_asing)
        let jumlah = this.props.dataMhs?.data_mhs_asing || {};
        let i =0;
        let year = [];
        let p_didik_baru = [];
        let pindahan = [];
        for(var key in jumlah){
            year[i] = key.substring(0,4) + "-" + key.substring(4, key.length);
            if(jumlah[key].peserta_didik_baru !== undefined){
                p_didik_baru[i] = jumlah[key].peserta_didik_baru;
            }else{
                p_didik_baru[i] = 0;
            }
            if(jumlah[key].pindahan !== undefined){
                pindahan[i] = jumlah[key].pindahan;
            }else{
                pindahan[i] = 0;
            }
            
            i++;
        }
        // substring(0, 4) + "." + x.substring(4, x.length)
        let x = 0;
        // console.log("YEARS =", year)
        // console.log("TAHUN =", year.substring(0,4)+"-"+year.substring(4, year.length));
        let mhs_asingPindahan = {
            labels: year,
              datasets: [
                {
                  label: 'Mahasiswa Baru',
                  fill: false,
                  lineTension: 0.1,
                  backgroundColor: '#b2d4eb',
                  borderColor: '#b2d4eb',
                  borderCapStyle: 'butt',
                  borderDash: [],
                  borderDashOffset: 0.0,
                  borderJoinStyle: 'miter',
                  pointBorderColor: '#b2d4eb',
                  pointBackgroundColor: '#b2d4eb',
                  pointBorderWidth: 1,
                  pointHoverRadius: 5,
                  pointHoverBackgroundColor: '#b2d4eb',
                  pointHoverBorderColor: '#b2d4eb',
                  pointHoverBorderWidth: 2,
                  pointRadius: 1,
                  pointHitRadius: 10,
                  data: p_didik_baru
                },
                {
                  label: 'Mahasiswa Pindahan',
                  fill: false,
                  lineTension: 0.1,
                  backgroundColor: '#cdebb2',
                  borderColor: '#cdebb2',
                  borderCapStyle: 'butt',
                  borderDash: [],
                  borderDashOffset: 0.0,
                  borderJoinStyle: 'miter',
                  pointBorderColor: '#cdebb2',
                  pointBackgroundColor: '#cdebb2',
                  pointBorderWidth: 1,
                  pointHoverRadius: 5,
                  pointHoverBackgroundColor: '#cdebb2',
                  pointHoverBorderColor: '#cdebb2',
                  pointHoverBorderWidth: 2,
                  pointRadius: 1,
                  pointHitRadius: 10,
                  data: pindahan
                },
              ]
          }
        return(
            <>
            <div className={`card-custom`}>
                {/* Header */}
                <div className="card-header border-0"  style={{textAlign:'center', paddingBottom: "0px"}}>
                <h5 className="card-title font-weight-bolder" style={{color:'#354f7a'}}>
                    Jumlah mahasiswa asing dan pindahan pertahun semester
                </h5>
                </div>
                {/* Body */}
                <div className="card-body pt-2">
                    <Bar data={mhs_asingPindahan} options={this.options} />
                </div>
            </div>
            </>
        )
    }
}
export default DiagramMhsAsing;